import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { withStyles } from "@material-ui/core/styles";

import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";

import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";

import CartItemPriceRow from "./CartItemPriceRow";
import CartSizeLines from "./CartSizeLines";
import BrandLogoImage from "./../common/BrandLogoImage";
import {
  EuropeanStockBadge,
  EuropeanStockNotice,
  EU_STOCK_TONE,
} from "./../common/EuropeanStockMark";
import { getTireAvailabilityDetails } from "./../list/tireAvailabilityDetails";
import commons from "./../common/commons";

const hebrewLables = {
  freeShipping: "משלוח חינם",
  lastPurchase: "רכישה אחרונה: {x}",
  outStock: "לא במלאי",
  preSale: "צפי הגעה: %s",
  inStock: "במלאי מיידי",
  likeButtonTextToggleOff: "לחץ לסמן שאתה אוהב את המוצר",
  learnMoreButtonText: "מידע נוסף",
  addToCartButtonText: "הזמנה",
  showMoreArrowText: "פתח לעוד מידע",
  removeItemFromCart: "הסר מהעגלה",
};

const styles = (theme) => ({
  card: {
    maxWidth: 400,
    marginTop: 40,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
  },
  content: {
    padding: 5,
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  media: {
    height: 194,
    backgroundPosition: "top",
  },
  brandLogo: {
    position: "absolute",
    maxHeight: 26,
    top: 3,
    right: 3,
  },
  outOfStock: {
    margin: 8,
    background: "#ba2218",
    color: "#fefefe",
  },
  button: {
    margin: theme.spacing(),
  },
  cardHeader: {
    flip: false,
    direction: "ltr",
  },
  cardMediaContainer: {
    position: "relative",
  },
  preOrder: {
    margin: 8,
    background: "#0d9b4b",
    color: "#fefefe",
  },
  euCard: {
    borderTop: `4px solid ${EU_STOCK_TONE.accent}`,
  },
  euBlock: {
    width: "100%",
    boxSizing: "border-box",
    marginTop: 8,
    padding: "0 8px 8px",
  },
});

class CartItem extends React.Component {
  state = { expanded: false };

  removeItemFromCart = () => {
    this.props.onRemoveFromCart(this.props.data.ean);
  };

  render() {
    const { classes, data, cardCount, currentShipment, availabilityContext } =
      this.props;

    const {
      displayName,
      brand,
      ean,
      cdn = false,
      displaySize,
      visibility = "none",
      source,
    } = data;

    const primaryPhoto = commons.getProductPrimaryImage(
      cdn,
      ean,
      source === "georgia"
    );

    const extraStyles = {};
    if (cardCount === 0) {
      extraStyles.marginTop = "10px";
    }

    let stockLabel;
    const displayGreenVisibilityChip =
      visibility === "instock" || visibility === "preorder" ? true : false;
    const displayOutOfStock = visibility === "outofstock";

    switch (visibility) {
      case "instock":
        stockLabel = hebrewLables.inStock;
        break;
      case "preorder":
        stockLabel = hebrewLables.preSale.replace("%s", currentShipment);
        break;
    }

    const availability = getTireAvailabilityDetails(data, availabilityContext);
    const isEu = availability.kind === "eu";

    return (
      <Card className={classNames(classes.card, isEu && classes.euCard)} style={extraStyles}>
        <CardHeader
          className={classes.cardHeader}
          title={displayName}
          subheader={brand}
        />
        <Divider />
        <div className={classes.cardMediaContainer}>
          <div className={classes.brandLogoContainer}>
            <BrandLogoImage
              brand={brand}
              className={classes.brandLogo}
            />
          </div>
          <CardMedia
            className={classes.media}
            image={primaryPhoto.url}
            title={`${brand} ${displayName} ${displaySize}`}
          />
        </div>
        <Divider />
        <CardContent className={classes.content}>
          <CartItemPriceRow
            data={data}
            quantity={this.props.quantity}
            onChangeQuantity={this.props.onChangeQuantity}
          />

          <CartSizeLines product={data} />

          {displayOutOfStock && (
            <div className={classes.chipsContainer}>
              <Chip
                className={classNames(classes.outOfStock)}
                label={hebrewLables.outStock}
              />
            </div>
          )}

          {displayGreenVisibilityChip && (
            <div className={classes.chipsContainer}>
              <Chip
                className={classNames(classes.preOrder)}
                label={stockLabel}
              />
            </div>
          )}

          {isEu ? (
            <div className={classes.euBlock} dir="rtl">
              <EuropeanStockBadge label={availability.label} />
              <EuropeanStockNotice details={availability} />
            </div>
          ) : null}

        </CardContent>
        <CardActions className={classes.actions}>
          <Button variant="contained" onClick={this.removeItemFromCart}>
            {hebrewLables.removeItemFromCart}
          </Button>
        </CardActions>
      </Card>
    );
  }
}

CartItem.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  currentShipment: PropTypes.string,
  availabilityContext: PropTypes.object,
  quantity: PropTypes.number.isRequired,
  cardCount: PropTypes.number.isRequired,
  onRemoveFromCart: PropTypes.func.isRequired,
  onChangeQuantity: PropTypes.func.isRequired,
};

export default withStyles(styles)(CartItem);
